import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Ship } from 'app/_models/ship';
import { Entity } from 'app/_models/entity';
import { EntityService } from 'app/_services/entity.service';
import { ShipService } from 'app/_services/ship.service';
import { Filter } from 'app/shared/filter';
import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { SelectItem } from 'primeng/primeng';
import { OptionMapper } from 'app/_models/pojos';
import { DocumentFilter } from 'app/_models/document';
import { DocumentService } from 'app/_services/document.service';

@Component({
  selector: 'app-document-filter',
  templateUrl: './document-filter.component.html',
})
export class DocumentFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Input() loading: boolean;
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: DocumentFilter;

  documentTypes: OptionMapper[] = [];

  ships: SelectItem[] = [];
  selectedShips: Ship[];

  buyers: SelectItem[] = [];
  selectedBuyers: Entity[];

  date: Date;

  constructor(
    private fb: FormBuilder,
    private shipService: ShipService,
    private entityService: EntityService,
    private documentService: DocumentService,
    private router: Router,
    private httpErrorHandler: HttpErrorHandler
  ) {
    super();
    this.form = fb.group({
      document_type: [''],
      ship: [''],
      buyer_entity: [''],
      date: [''],
    });
  }

  ngOnInit() {
    this.filter = new DocumentFilter(this.filterParams);
    if (this.filter.date) {
      this.date = new Date(this.filter.date);
    }

    this.getShips();
    this.getBuyers();
    this.getdocumentTypes();
  }

  getShips() {
    this.shipService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', false);
        this.selectedShips = this.selectMultipleDropdownItems(response.results, this.filter.ship);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  getBuyers() {
    this.entityService.list(1, 10000, '&type=c&type=cv', '').subscribe(
      (response) => {
        this.buyers = this.parseDropdownResults(response, new Entity(), 'name', false);
        this.selectedBuyers = this.selectDropdownItem(response, this.filter.buyer_entity);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
  getdocumentTypes() {
    this.documentService.getOptions().subscribe(
      (data) => {
        this.documentTypes = OptionMapper.generateCollectionFromApi(data['actions']['POST']['document_type']['choices']);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  onSubmit() {
    if (this.date) {
      this.date.setHours(23);
      this.filter.date = this.date.toISOString().substring(0, 10);
    }

    if (this.selectedShips) {
      this.filter.ship = this.selectedShips;
    }

    if (this.selectedBuyers) {
      this.filter.buyer_entity = this.selectedBuyers;
    }
    if (this.filterParams['o'] !== undefined) {
      this.filter['o'] = this.filterParams['o'];
    }

    const params = DocumentFilter.serializeRouterParams(this.filter);
    const serialize_params = this.filter.serializeQueryParams(params);
    this.onApplyFilter.emit(serialize_params);
    this.router.navigate(['/documents', DocumentFilter.serializeRouterParams(this.filter)]);
  }
}



// WEBPACK FOOTER //
// ./src/app/documents/document-filter/document-filter.component.ts